import { PrintLocation } from '@modeso/types__aumico-lib-annualreport-be';
import { PDFSectionIds } from '../../enums/pdf-tron/pdf-section-ids.enum';
import { IBalanceSheetData } from './balance-sheet-data.interface';
import { IEquityMovementScheduleData } from './equity-movement-schedule-data.interface';
import { IFinancialTableData } from './financial-table-data.interface';
import { FixedAssetScheduleRowFormatted } from './fixed-assets-schedule-row-formatted.interface';
import { ISubsection } from './subsection.interface';

export interface ISectionData {
    sectionId: PDFSectionIds;
    title: string | null;
    noPrevious?: boolean;
    /** FX (REV-21512): true when the BS/ER section prints both currencies (twin columns). */
    isFxFormat?: boolean;
    showReference?: boolean;
    showRatios?: boolean;
    hasSignature?: boolean;
    data?:
        | IBalanceSheetData
        | IFinancialTableData[]
        | string
        | IEquityMovementScheduleData
        | FixedAssetScheduleRowFormatted[]
        | null;
    tables?: IFinancialTableData[][];
    ccrTables?: IFinancialTableData[][];
    subsections?: ISubsection[];
    isLast?: boolean;
    printLocation?: PrintLocation;
    sortOrderId?: number;
    showInTOC?: boolean;
    description?: string;
    ccrFootnote?: string;
    fileId?: string;
    fileName?: string;
    showPageNumbers?: boolean;
    showTitleInReport?: boolean;
}
